export default "__VITE_ASSET__200e6002__"